const LANG_CONST = {
  titles: {
    resolve_bookings: 'Resolve Bookings',
    working_schedule: 'Working Schedule',
    home: 'Home',
    earnings: 'Earnings',
    health: 'Health',
    cards: 'Cards',
    health_marker_detail: 'Marker Detail',
    health_marker_list: 'All Markers',
    health_document_detail: 'Document Detail',
    health_upload_review: 'Upload Health Report',
    edit_slot: 'Edit Slot',
    add_slot: 'Add Slot',
    add_slots: 'Add Slots',
    add_analyses: 'Add analyses',
    edit_analyses: 'Edit analyses',
    notifications_blocked: 'Notifications blocked',
    enable_chat_notification: 'Enable chat notifications',
    pw_reset: 'Password reset',
    patients: 'Patients',
    forgot_pw: 'Forgot Password',
    sessions: 'Active Sessions',
    clinic_info: 'Clinic Information',
    clinic_info_short: 'Clinic Info',
    profile_info: 'Personal Information',
    profile_info_short: 'Personal Info',
    payment_details: 'Payment Details',
    invoices: 'Invoices',
    invoice: 'Invoice',
    bank_details: 'Bank Details',
    security: 'Email and Password',
    notifications: 'Notifications',
    notification: 'Notification',
    clinic_charges: 'Charges',
    stats: 'Stats',
    charges: 'Charges',
    locations: 'Locations',
    clinic_locations: 'Locations',
    appointment_questions: 'Questions',
    vital_info: 'Vital Information',
    wallet: 'Wallet',
    certificates: 'Certificates',
    managers: 'Managers',
    connected_accounts: 'Connected Accounts',
    doctors: 'Doctors',
    treatments: 'Treatments',
    treatment_detail: 'Treatment detail',
    categories: 'Categories',
    all_categories: 'All categories',
    doctor_info: 'Doctor Information',
    patient_info: 'Patient Information',
    analyses: 'Analyses',
    can_view_treatment: 'Can view Treatment',
    discovery: 'Discovery',
    signup: 'Sign Up',
    qualifications: 'Qualifications',
    add_new_location: 'Add new location',
    invoice_details: 'Invoice details',
    can_view_analyse: 'Can view Analyse',
    appointments: 'Appointments',
    gallery: 'Gallery',
    contact: 'Contact',
    clinics: 'Clinics',
    add_doctor: 'Add doctor',
    add_managers: 'Add managers',
    edit_doctor: 'Edit Doctor',
    add_patient_to_personal: 'Add new patients to your personal account',
    add_patient_to_clinic_doctor: 'Add new patients to your clinic account',
    add_patients: 'Add new patients',
    edit_patient: 'Edit patient',
    edit_invitation: 'Edit invitation',
    printer_request: 'Printer Request',
    settings: 'Settings',
    add_treatment: 'Add treatment',
    appointment_detail: 'Appointment Detail',
    edit_appointment_detail: 'Edit Appointment Details',
    add_new_charge: 'Add new charge',
    add_new_card: 'Add New Card',
    add_balance: 'Add Balance',
    active_sessions: 'Active Sessions',
    my_stats: 'My Stats',
    payment: 'Payment',
    diary: 'Diary',
    breast_surgery: 'Breast surgery',
    new_entry: 'New Entry',
    all_journeys: 'All Journeys',
    messages: 'Messages',
    my_schedule: 'My Schedule',
    manager_locations: 'Manager Locations',
    app_settings: 'App Settings',
    life_track: 'Life Track',
    make_appointment: 'Make Appointment'
  },
  select_card: 'Select card',
  confirm_payment: 'Confirm Payment',
  invoice: 'Invoice',
  treat: 'Treat',
  day: 'Day',
  week: 'Week',
  month: 'Month',
  appt: 'Appt',
  earn_dot: 'Earn.',
  ticket: 'Ticket',
  history: 'History',
  delay: 'Delay',
  first_view: 'First view',
  expire_in: 'Expire in',
  self_destruct: 'Self destruct',
  timer: 'Timer',
  daily: 'Daily',
  monthly: 'Monthly',
  weekly: 'Weekly',
  free_chat_doctor: ' Doctors can write for free',
  free_chat_clinic: ' Clinics can write for free',
  enter_patient_first_name: 'Enter patient first name',
  enter_patient_last_name: 'Enter patient last name',
  session: 'session',
  slot: 'Slot',
  start_time: 'Start Time',
  end_time: 'End Time',
  deleted: 'Deleted',
  time: 'Time',
  analyze_file: 'Analyse file',
  analyze_title: 'Analyze title',
  add_your_title: 'Add your title',
  need_help: 'Need help?',
  your_address: 'Your address',
  earnings: 'Earnings',
  tickets: 'Tickets',
  unpay: 'Unpay',
  paid: 'Paid',
  choose_file: 'Choose file',
  email_news: 'Email news',
  email_subscriptions: 'Email subscriptions',
  webpush_subscriptions: 'Web push notifications',
  disease: 'Disease',
  photos_files: 'Photos / Files',
  answer: 'Answer',
  answer_here: 'Answer here',
  types: 'Types',
  num: 'Number',
  txt: 'Text',
  verify_your_email: 'Verify Your Email',
  last_appointment: 'Last Appointment',
  year: 'Year',
  change_pw: 'Change Password',
  change_email: 'Change Email',
  free: 'Free',
  no_clinic: 'No Clinic',
  message: 'Message',
  appointments: 'Appointments',
  treatments: 'Treatments',
  choose: 'Choose',
  log_in: 'log in',
  forward_to: 'Forward to',
  change_num: 'Change number',
  change_phone_number: 'Change Phone Number',
  verifying_num: 'Verifying Number',
  choose_your: 'Choose Your',
  with_lifeapp: 'With LifeApp',
  set_new_pw: 'Set new password',
  choose_your_username: 'Choose your username',
  language: 'Language',
  hi: 'Hi',
  delivery_address: 'Delivery Address',
  active_clinic: 'Active clinics',
  pending_to_approve: 'Pending to approve',
  consultant_charges: 'Consultant charges',
  currency: 'Currency',
  doctor_type: 'Doctor Type',
  year_of_starting: 'Year Of Starting',
  first_consultation: 'First Consultation',
  not_set: 'Not Set',
  no_of_message: 'No of messages',
  extra_message: 'Extra message',
  user: 'User',
  fullname: 'Full Name',
  phone: 'Phone',
  email: 'Email',
  name: 'Name',
  clinic_name: 'Clinic Name',
  email_address: 'Email Address',
  first_name: 'First Name',
  last_name: 'Last Name',
  patient_first_name: 'Patient First Name',
  patient_last_name: 'Patient Last Name',
  phone_number: 'Phone Number',
  username: 'Username',
  suggestion: 'Suggestion',
  password: 'Password',
  optional: 'Optional',
  verified: 'Verified',
  not_verified: 'Not verified',
  processing: 'Processing',
  manager_at: 'Manager at {:name}',
  back_to: 'Back to {:name}',
  back_to_txt: 'Back to',
  amount_year: '{:amount} year',
  amount_years: '{:amount} years',
  amount_day: '{:amount} day',
  amount_days: '{:amount} days',
  next_treatment_in: 'Next update in {:amount} {:unit}',
  hospital: 'Hospital',
  select_date: 'Select date',
  diagnosis: 'Diagnosis',
  recommendation: 'Recommendation',
  recommendations: 'Recommendations',
  prescribe_medicine: 'Prescribed Medicine',
  medicine_name: 'Medicine Name',
  dosage: 'Dosage',
  duration: 'Duration',
  clinic: 'Clinic',
  note: 'Note',
  treatment_files: 'Treatment Files',
  location: 'Location',
  total_treatments: 'Total treatments',
  experience: 'Experience',
  total_experience: 'Total Experience',
  total_patients: 'Total Patients',
  book_available: 'Booking available',
  patient_feedback: 'Patient feedback',
  status: 'Status',
  is_your_health_improved: 'Is your health improved?',
  side_effects: 'Side effects',
  studies_at: 'Studies at {:school}',
  practicing_at: 'Practicing at {:school}',
  date_of_joining: 'Date Of Joining',
  joining_date: 'Joining Date',
  treatment: 'Treatment',
  amount_happy_patients: '{:amount} of Happy Patients',
  virtual: 'Virtual',
  independent: 'Independent',
  patients: 'Patients',
  users: 'Users',
  patient: 'Patient',
  appointment_status: 'Appointment Status',
  diagnostic: 'Diagnostic',
  doctors: 'Doctors',
  clinics: 'Clinics',
  doctor: 'Doctor',
  actions: 'Actions',
  card_preview: 'Card Preview',
  date: 'Date',
  age: 'Age',
  gender: 'Gender',
  birthday: 'Birthday',
  shared_files: 'Shared files',
  media: 'Media',
  doze: 'Doze',
  days: 'days',
  timing: 'Timing',
  type: 'Type',
  details: 'Details',
  purpose_of_treatment: 'Purpose of treatment',
  description: 'Description',
  medicine: 'Medicine',
  next_update: 'Next Update',
  select: 'Select',
  select_a_doctor: 'Select an existing doctor',
  select_a_patient: 'Select an existing patient',
  upload_file: 'Upload prescription or file',
  upload_cert: 'Upload Certificate',
  custom: 'Custom',
  clients: 'Clients',
  all: 'All',
  your_email_address: 'Your email address',
  your_phone_number: 'Your phone number',
  your_username: 'Your username',
  confirm_password: 'Confirm Password',
  city: 'City',
  institution: 'Institution',
  invoice_no: 'Invoice no',
  billing_to: 'Billing to',
  sr: 'Sr.',
  price: 'Price',
  vat: 'VAT',
  total: 'Total',
  grand_total: 'Grand total',
  payment_method: 'Payment method',
  card: 'Card',
  card_number: 'Card number',
  valid_thru: 'Valid thru',
  by_online: 'By Online',
  amount: 'Amount',
  invoice_no_dot: 'Invoice no.',
  serie_invoice: 'Serie/Invoice',
  email_phone: 'Email/Phone',
  invoice_date: 'Invoice Date',
  select_time: 'Select time',
  treatment_prefer: 'Preferred treatment',
  in_office: 'In office',
  office: 'Office',
  pay_life: 'Pay life',
  online: 'Online',
  offline: 'Offline',
  work_location: 'Work location',
  hospital_name: 'Hospital name',
  sub_speciality: 'Sub-speciality',
  speciality: 'Speciality',
  specialist: 'Specialist',
  active_doctor: 'Active doctors',
  degree: 'Degree',
  commission: 'Commission',
  doctor_grade: 'Doctor Grade',
  clinic_hospital: 'Clinic/Hospital',
  about_me: 'About me',
  free_chat: 'Free chat',
  free_messages: 'Free messages',
  serie: 'Serie',
  schedule: 'Schedule',
  fee: 'Fee',
  title: 'Title',
  active: 'Active',
  added_date: 'Added Date',
  admin: 'Admin',
  accesses: 'Accesses',
  install_app: 'Install LifeApp',
  clinic_location: 'Clinic Location',
  chat_ticket: 'Chat ticket',
  chat_tickets: 'Chat Tickets',
  search: 'Search',
  invite: 'Invite',
  bulk: 'Bulk',
  phone_or_email: 'Phone or Email',
  date_of_birth: 'Date of Birth',
  tags: 'Tags',
  saved: 'Saved',
  field: 'Field',
  select_contact: 'Select Contact',
  select_deselect_all: 'Select/Deselect All',
  available: 'Available',
  not_available: 'Not Available',
  unavailable: 'Unavailable',
  start_date: 'Start Date',
  end_date: 'End Date',
  request_detail: 'Request Detail',
  email_verification: 'Email Verification',
  current_pw: 'Current Password',
  new_pw: 'New Password',
  verify_pw: 'Verify Password',
  verification_code: 'Verification code',
  verification_pw: 'Verification Password',
  or: 'or',
  manager: 'Manager',
  def: 'Default',
  question: 'Question',
  symptoms: 'Symptoms',
  for_txt: 'for',
  charges: 'Charges',
  done: 'Done',
  zero: 'Zero',
  soon: 'Soon',
  invitations: 'Invitations',
  number_of_weeks: 'Number of weeks',
  select_number_of_weeks: 'Select number of weeks',
  period: 'Period',
  purchase: 'Purchase',
  not_found_obj: {
    error: 'Error 404',
    title_before: 'Page',
    title_highlight: 'Lost',
    title_after: 'in the System',
    description:
      "Looks like this page took an unexpected detour. Don't worry – your health journey with LifeApp is still on track. Let's get you back to where you need to be."
  },
  contact_us_obj: {
    title: 'Contact Us',
    via_email: 'Via Email: contact@lifeapp.com',
    via_phone: 'Via Phone Number: +1 507 774 0755',
    via_link: 'Via this Link: https://www.lifeapp.com'
  },
  address: {
    delivery_address: 'Delivery Address',
    address: 'Address',
    address_line: 'Address Line',
    country: 'Country',
    state: 'State',
    city: 'City',
    zip: 'Postal Code'
  },
  buttons: {
    add_media: 'Add Media',
    add_new_patient: 'Add New Patient',
    cancel_all: 'Cancel All',
    resolve_bookings: 'Resolve Bookings',
    turn_off_extra_bookings: 'Turn off extra bookings',
    remake: 'Remake',
    apply_full_year: 'Apply to full year',
    schedule: 'Schedule',
    add_hour_frame: 'Add hour frame',
    add_question: 'Add new question',
    not_now: 'Not Now',
    enable: 'Enable',
    contact_support: 'Contact LifeApp Support',
    find_doctor: 'Find a Doctor',
    home: 'LifeApp Home',
    unpay: 'Unpay',
    cancel_appointment: 'Cancel appointment',
    got_it: 'Got it',
    new_diary: 'New Diary',
    remove_diary: 'Remove Diary',
    save_changes: 'Save Changes',
    drag_upload: 'Drag files to upload',
    upload_diploma: 'Click here to upload diploma',
    verify_number: 'Verify Number',
    save_pw: 'Save Password',
    resend: 'Resend',
    skip_for_now: 'Skip for now',
    send_confirmation_code: 'Send Confirmation Code',
    sending: 'Sending',
    continue: 'Continue',
    verify: 'Verify',
    verifying: 'Verifying',
    begin_now: 'Begin Now',
    click_to_resend: 'click to resend',
    verify_in: 'Verify in {:duration}',
    resend_in: 'Resend in {:duration}',
    verification_in: 'Verification in {:duration}',
    reset_pw_in: 'Reset Password in {:duration}',
    login_in: 'Login in {:duration}',
    send_verification_in: 'Send Verification in {:duration}',
    send_verification: 'Send Verification',
    reset_pw: 'Reset Password',
    set_dates: 'Set Dates',
    add_slot: 'Add Slot',
    add_slots: 'Add Slots',
    ask_question: 'Ask Question',
    pay_now: 'Pay Now',
    joined: 'Joined {:clinic}',
    cancel: 'Cancel',
    save: 'Save',
    create: 'Create',
    delete_account: 'Delete Account',
    logout: 'Logout',
    yes: 'Yes',
    no: 'No',
    ok: 'Okay',
    less_categories: 'Less categories',
    more_categories: 'More categories',
    view_more: 'View more',
    next: 'Next',
    previous: 'Previous',
    select: 'Select',
    add_feedback: 'Add feedback',
    edit_feedback: 'Edit feedback',
    view_profile: 'View Profile',
    see_more: 'See more',
    forward: 'Forward',
    remove: 'Remove',
    edit: 'Edit',
    reply: 'Reply',
    add_treatment: 'Add treatment',
    edit_treatment: 'Edit treatment',
    add_gallery: 'Add Gallery',
    main_gallery: 'Main Gallery',
    edit_gallery: 'Edit Gallery',
    add_analyses: 'Add Analyses',
    add_new: 'Add new',
    add_file: 'Add File',
    add_files: 'Add Files',
    drap_or_click_here: 'Drag files or click here to upload media',
    privacy_setting: 'Privacy setting',
    privacy: 'Privacy',
    create_account: 'Create Account',
    signup_with_email: 'Sign up with Email',
    continue_with_google: 'Continue with Google',
    add_location: 'Add Location',
    start_now: 'Start Now',
    download: 'Download',
    pay: 'Pay',
    close: 'Close',
    done: 'Done',
    confirm_refund: 'Confirm Refund',
    refund: 'Refund',
    add_invoice: 'Add invoice',
    add_more: 'Add more',
    add_more_weeks: 'Add more weeks',
    add_analyse: 'Add analyse',
    view: 'View',
    delete: 'Delete',
    ai_interpretation: 'AI interpretation',
    not_attended: 'Not Attended',
    attended: 'Attended',
    add_appointment: 'Add appointment',
    doctors_appointments: 'Doctors appointments',
    rebook: 'Rebook',
    confirm: 'Confirm',
    chat_video: 'Chat Video',
    reschedule: 'Reschedule',
    actions: 'Actions',
    view_all: 'View all',
    make_appointment: 'Make appointment',
    reschedule_appointment: 'Reschedule appointment',
    add_new_appointment: 'Add new appointment',
    send_a_message: 'Send a message',
    login: 'Login',
    logging: 'Logging in',
    signup: 'Sign up',
    chat_support: 'Chat support',
    end_conversation: 'End conversation',
    join_app: 'Join LifeApp',
    scroll_down: 'Scroll down',
    scroll_top: 'Scroll top',
    locations: 'Locations',
    add_manager: 'Add manager',
    back: 'Back',
    install: 'Install',
    add: 'Add',
    back_to_app: 'Back to LifeApp',
    approve: 'Approve',
    accept: 'Accept',
    preview: 'Preview',
    crop: 'Crop',
    upload: 'Upload',
    book: 'Book',
    book_appointment: 'Book Appointment',
    send_invite: 'Send invite',
    import_invite: 'Import csv/vcf',
    invite: 'Invite',
    add_first_doctor: 'Add your first doctor',
    finish: 'Finish',
    next_day: 'Next day',
    order_card_free: 'Order cards free',
    send_request: 'Send request',
    edit_address: 'Edit address',
    copy_link: 'Copy link'
  },
  payment_txt: 'Payment',
  payment: {
    iban: 'IBAN/ Account',
    swift: 'Swift',
    revolut_id: 'Revolut ID',
    bank: {
      name: 'Bank Name',
      address: 'Bank Address',
      country: 'Bank Country',
      state: 'Bank State',
      city: 'Bank City',
      zip: 'Bank Postal Code'
    }
  },
  validation: {
    file_too_big: 'File size cannot exceed {:size}',
    need_input_ques: 'You need to enter a question',
    avatar_used:
      'Please use a non duplicate profile photo, to avoid account identification confusion.',
    file_invalid: 'File type not allowed.',
    video_invalid: 'Video file is invalid.',
    link_invalid: 'This link has expired or is no longer active',
    required: '{:label} is required',
    invalid: '{:label} is invalid',
    email_or_phone: 'Please enter email or phone number',
    tags: 'Tags may only contain alphanumeric characters as well as hyphens. Minimum length is 2 chars, maximum -20.',
    media_limit: 'Maximum is {:limit}',
    image_resolution: 'Image should be at least {:resolution} in resolution.',
    time_slot_min: 'Time slot must be at least 20 minutes.',
    start_end_time: 'Start Time should be greater then End Time',
    conflict_slot_time: 'The selected time conflicts with an existing slot'
  },
  visit_card: {
    order_timeline: 'Order Timeline',
    order_placed: 'Order placed',
    order_placed_des: 'Your card request has been received',
    order_placed_waiting_approval: 'Waiting for admin approval...',
    processing: 'Processing',
    processing_des: 'Admin is reviewing and processing your request',
    cancelled: 'Cancelled',
    cancelled_des: 'Your card request has been cancelled',
    cancelling: 'Cancelling',
    cancelling_des: 'Your cancelled request has been received',
    cancelling_waiting_approval: 'Waiting for admin approval...',
    delivered: 'Delivered',
    delivered_des: 'Your card has been delivered',
    cards_ordered_successfully_title: 'You successfully ordered 100 cards',
    cards_ordered_successfully: 'Your cards wil be delivered at {:address} until around {:date}',
    order_your_cards: 'Order your cards',
    card_order:
      "It's free!\nOrder 100 cards with your LifeApp details, to promote your services to your customers and patients."
  },
  notice: {
    no_schedule: 'You have no schedule on {:time}. Generate now?',
    reschedule_diff:
      'The new time slot has a different rate. Your current appointment will be cancelled and a new one will be created.',
    booking_slot_when_disabled:
      'You have active bookings in the month, which need to be canceled or rescheduled manually',
    allow_notification: 'Allow notifications?',
    notification_disabled: 'Notifications are disabled in your phone settings.',
    update_required: 'Update Required',
    no_add_more_hour: "You can't add more hours",
    cannot_open_settings: 'Settings could not be opened.',
    failed_to_import_contacts:
      'Failed to import contacts\n\nAn error occurred while trying to access contacts.',
    permission_denied: 'Permission denied\n\nPlease allow access to contacts in settings.',
    no_camera_detected:
      'No camera detected\n\nNo camera were detected on this device. Make sure you granted access to your cameras from Settings.',
    camera_permission: 'Camera permission\n\nLifeApp requires access to your phone camera',
    mic_permission: 'Mic permission\n\nLifeApp requires access to your microphone',
    join_title: 'Welcome to the Team!',
    you_joined: "You've successfully joined {:name}",
    cancelled_appointment: 'The appointment has been cancelled',
    cancel_appointment:
      'Are you sure you want to cancel this appointment?\n\nThis appointment will be moving to History once you cancel it.',
    appointment_taken:
      'An appointment is already scheduled for {:dateTime}.\n\nPlease select an available time slot.',
    slot_only_future_date: 'You can add slots only for future dates.',
    sent_sms: 'A 5-digit code has been sent to your phone.\n\nPlease enter it below to continue.',
    delete_slot: 'Are you sure you want to remove this slot?',
    delete_selected: 'Delete selected {:name}?',
    delete_all_messages: `Are you sure you want to delete all message history with {:name}?`,
    required_mic_access:
      'You need a mic to be able to record an audio message.\nMake sure you enabled microphone access.',
    required_choose_user_type: 'You need to select an option: User, Doctor or Clinic',
    email_verified: 'Your email is now verified and ready to use',
    successfully_verified_phone: 'Your phone has been successfully verified.',
    sent_code_to: 'We’ve sent your verification code to',
    no_receive_otp: "Didn't receive the OTP?",
    no_receive_code: "Didn't receive the code?",
    no_receive_email: "Didn't receive the email?",
    joined_clinic:
      "You've successfully joined {:name}. You now have access to the clinic's patients, appointments, and all team features.",
    forgot_code_sent: `The password reset code has already been sent to your {:type}. Wait {:blockedInMin} before retrying`,
    verify_code_sent_phone: `The verification code has already been sent to your phone. Wait {:blockedInMin} before retrying`,
    verify_code_sent_email: `The verification email has already been sent to your email. Wait {:blockedInMin} before retrying`,
    account_verifying: 'You verification is pending.\n\nWe’ll update you shortly.',
    delete_account: 'Are you sure want to delete account?',
    delete_location: 'Are you sure you want to delete this location?',
    refund_invoice:
      'Are you sure you want to refund this invoice?\n\nThis action cannot be undone and the payment will be returned to the patient.',
    select_some_dates: 'Please select some dates first.',
    delete: 'Are you sure want to delete?',
    cancel: 'Are you sure want to cancel?',
    resend: 'Are you sure want to resend?',
    sent_invitations:
      'Your invitations has been sent successfully.\n\nThe {:type} will receive instructions to join their account.',
    sent_invitation:
      'Your invitation has been sent successfully.\n\nThe {:type} will receive instructions to join their account.',
    change_success: 'Changes saved successfully.',
    add_success: 'The addition was successful..',
    add_only_100: 'You can add a maximum of 100 invitations per batch.',
    sent_only_100: 'You can send a maximum of 100 invitations per batch.',
    limit_reached: 'Limit reached',
    unavailable_link: 'Your invitation is no longer available, contact the sender for more details',
    clinic_disabled_account:
      'Your account at {:clinic} is not active, Please contact your clinic for details.\n\nYou can still view your messages',
    disabled_account:
      'Your account is deactivated, Please contact support for details.\n\nYou can still view your messages',
    disabled_doctor_for_clinic: 'Doctor {:doctor} isn’t available.',
    disabled_doctor: 'Doctor {:doctor} isn’t available. Contact support or choose a new doctor.',
    disabled_clinic_doctor:
      'Doctor {:doctor} isn’t available. Contact the clinic or choose a new doctor.',
    not_available_doctor: 'Dr. {:doctor} is currently unavailable',
    not_available_doctor_end_date: 'Dr. {:doctor} is currently unavailable until {:endDate}'
  },
  manager_no_permissions: {
    doctors:
      'Your account does not have the necessary permissions to manage doctors.\n\nPlease reach out to the clinic administrator to request access',
    appointments:
      'Your account does not have the required permissions to add or remove appointments.\n\nPlease reach out to the clinic administrator to request access',
    treatments:
      'Your account does not have the required permissions to manage treatments.\n\nPlease contact the clinic administrator to request access',
    customer_support:
      'Your account does not have the necessary permissions to handle customer support.\n\nPlease reach out to the clinic administrator to request access'
  },
  text: {
    file_expired: 'This file is expired',
    free: '{:num} free',
    booked: '{:num} booked',
    free_slot: '{:num} free slot',
    free_slots: '{:num} free slots',
    appointment: '{:num} appointment',
    appointments: '{:num} appointments',
    no_schedule: 'No schedule configured',
    enable_disable_intervals: 'Enable/Disable intervals',
    setup_time_slot: 'Setup your time slots',
    choose_working_day: 'Choose working days',
    choose_working_week: 'Choose working weeks with this rule',
    choose_duration: 'Choose the time allocated per consultation including the break',
    speciality_des:
      'Select your area of medical expertise (e.g., Cardiology, Dermatology, Orthopedics).',
    notifications_blocked:
      'To receive notifications, please enable them in your browser settings for this site.',
    enable_chat_notification: 'Get live chat notifications, when you receive new messages',
    google_failed: 'Google sign-in was cancelled or failed. Please try again.',
    click_to_login: 'Click below to log in magically.',
    pw_reset_successfully: 'Your password has been successfully reset.',
    choose_avatar: 'Please choose a different photo to easier identify your accounts',
    tag_placeholder: 'Type to search or create tag (min 3 chars, alphanumeric only)',
    edit_subscription_des: 'We email news on the lastest technology and offers.',
    edit_subscription_title: 'Edit your email preferences below',
    symptoms_here: 'Write your symptoms here',
    sms_notifications: 'Sms {:num}',
    type_here: 'Type here',
    reminder_label: 'Reminder {:num}',
    other_location_charges: 'Other location Charges',
    per_doctor_charges: 'Per doctor charges',
    follow_up_duration_des:
      'Define how many days a patient can contact you for follow-ups after the initial consultation.',
    follow_up_period: 'Follow Up Period',
    delete_for_everyone: 'Delete for Everyone',
    also_delete_for_name: `Also delete for {:name}`,
    set_standard_hours: 'Set standard hours',
    config_standard_hours: 'Configure the standard hours of operation for this location.',
    change_your_pw: 'Change your account password',
    change_your_email: 'Change your Email Address',
    change_your_phone: 'Change your Phone Number',
    check_inbox_email: 'Please check your inbox and confirm your address.',
    verification_email_sent:
      "We've sent a verification link to the email address you provided.\n\nPlease check your inbox and click the link to complete verification.",
    welcome_des: 'Easily connect with top doctors via video or chat from your phone app',
    pw_least_chars: 'Must be at least 8 characters.',
    new_pw_should_diff_old_pw: 'Your new password must be different to previously used passwords.',
    enter_code_from: 'Enter code from {:type}',
    forgot_pw_no_worries: `No worries, we'll send you reset instructions.`,
    reset_by_email: 'Reset password by email',
    reset_by_phone: 'Reset password by phone number',
    lifeapp_des: 'LifeApp is a platform that connects patients with doctors and clinics.',
    login_des: 'Login to connect your doctors',
    enable_all: 'Enable all doctors and managers',
    disable_all: 'Disable all doctors and managers',
    discovery_not_found: 'Sorry, No Result Found\nWe couldn’t find the doctor you’re looking for.',
    search: 'Search...',
    no_results_yet: 'No results yet',
    nothing_found: 'Nothing found',
    enter_word: 'enter your word here',
    signup_connect_dr: 'Sign up to connect your doctors',
    signup_connect_clients: 'Sign up to connect your clients',
    set_up_clinic_info: 'Set up your clinic information',
    password_least_char: 'Password must be at least 8 characters',
    already_have_account: 'Already have an account?',
    are_doctor: 'Are you a doctor?',
    are_clinic: 'Are you a clinic?',
    signup_description: 'All info is strictly confidential',
    signup_location_description: 'Add Your Clinic Branches',
    login: 'Log in',
    click_here: 'Click here',
    empty_clinic_location: 'List Your Clinic for Discovery and add your locations',
    thank: 'Thanks!',
    signup_ready: 'Your have been successfully registered. your account is ready to go',
    choose: 'Choose {:attribute}',
    appointment_virtual_amount_prefix: 'You have to pay',
    appointment_virtual_amount_suffix: 'for Video Call',
    not_slot_yet: 'Not available slot yet',
    doctor_session_chat:
      '{:price} {:currency}/session ({:messagesCount} messages included - {:duration} days)',
    enter_here: 'Enter keyword here',
    enter: 'Enter {:attr}',
    forgot_pw: 'Forgot password?',
    dont_have_account: "Don't have an account?",
    welcome_best_app: 'The absolute best telemedicine app to date!',
    install_app: 'For a better experience on iOS and Android',
    handle_manager_access_in_location: `Handle {:access} in this location`,
    select_text: 'Select {:attr}',
    select_manager_for_location: 'Select your managers for this location',
    follow_up: `Follow up - resets in {:attr} days`,
    invite_doctor_title: `Invitation to join {:attr}.`,
    invite_doctor: `We are pleased to invite you to join the team.`,
    select_location_des: "Select the doctor's working locations",
    need_location: 'You need to have at least one location',
    type: 'type {:attr}',
    free_first_consultation_online: 'Fee for first online consultation.',
    free_first_consultation_in_person: 'Fee for first in-person consultation.',
    free_follow_up_online: 'Fee for follow-up online consultation.',
    free_follow_up_in_person: 'Fee for first in-person consultation.',
    add_doctor_for_schedule: 'You need to add at least one doctor before creating schedule slots.'
  },
  constants: {
    self_destruct_unit: {
      minutes: 'Minutes',
      hours: 'Hours',
      days: 'Days'
    },
    reminder_types: {
      email: 'Email',
      sms: 'SMS',
      push: 'Push'
    },
    reminder_time_unit: {
      minutes: 'Minutes',
      hours: 'Hours',
      days: 'days'
    },
    languages: {
      en: 'English',
      ro: 'Romanian',
      vi: 'Vietnamese',
      bg: 'Bulgarian'
    },
    card_order_status: {
      pending: 'Pending',
      processed: 'Processed',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
      cancelled_by_doctor: 'Cancelled by Doctor'
    },
    manager_access: {
      appointments: 'Appointments',
      treatments: 'Treatments',
      customerSupport: 'Chat Customer Support',
      doctors: 'Doctors'
    },
    doctor_types: {
      resident_doctor: 'Resident Doctor',
      specialist_doctor: 'Specialist Doctor',
      primary_doctor: 'Primary Doctor',
      general_practitioner: 'General Practitioner',
      nutritionist: 'Nutritionist',
      fitness_trainer: 'Fitness trainer',
      psychologist: 'Psychologist'
    },
    pay_types: {
      now: 'Pay now',
      later: 'Pay later'
    },
    privacy_setting: {
      only_me: 'Only Me',
      my_doctors: 'My Doctors',
      everyone: 'Everyone'
    },
    gender: {
      male: 'Male',
      female: 'Female',
      other: 'Other'
    },
    health_statuses: {
      in_process: 'In Process',
      completed: 'Completed'
    },
    medicine_period: {
      before_meal: 'Before Meal',
      after_meal: 'After Meal',
      any: 'Any'
    },
    medicine_times: {
      morning: 'Morning',
      lunch: 'Lunch',
      dinner: 'Dinner'
    },
    appointment_types: {
      virtual: 'Virtual',
      in_office: 'Office'
    },
    invoice_status: {
      unpaid: 'Unpaid',
      paid: 'Paid',
      refunded: 'Refunded',
      cancelled: 'Cancelled'
    },
    specialist: {
      'internal-medicine': 'Internal medicine',
      dermatovenerology: 'Dermatovenerology',
      'obstetrics-gynaecology': 'Obstetrics & Gynaecology',
      urology: 'Urology',
      pediatrics: 'Pediatrics',
      neonatology: 'Neonatology',
      gastroenterology: 'Gastroenterology',
      'pediatric-gastroenterology': 'Pediatric Gastroenterology',
      cardiology: 'Cardiology',
      'pediatric-cardiology': 'Pediatric Cardiology',
      'otolaryngology-ent': 'Otolaryngology (ENT)',
      hematology: 'Hematology',
      'laboratory-medicine': 'Laboratory medicine',
      pulmonology: 'Pulmonology',
      'pediatric-pulmonology': 'Pediatric Pulmonology',
      nephrology: 'Nephrology',
      'pediatric-nephrology': 'Pediatric Nephrology',
      neurology: 'Neurology',
      'pediatric-neurology': 'Pediatric Neurology',
      neurosurgery: 'Neurosurgery',
      radiotherapy: 'Radiotherapy',
      'radiology-and-medical-imaging': 'Radiology and medical imaging',
      oncology: 'Oncology',
      'pediatric-oncology-and-hematology': 'Pediatric oncology and hematology',
      'orthopedics-and-traumatology': 'Orthopedics and Traumatology',
      'pediatric-orthopedics': 'Pediatric orthopedics',
      'medical-recovery': 'Medical recovery',
      'infectious-diseases': 'Infectious diseases',
      endocrinology: 'Endocrinology',
      'allergology-and-clinical-immunology': 'Allergology and Clinical Immunology',
      'diabetes-nutrition-and-metabolic-diseases': 'Diabetes, Nutrition and Metabolic Diseases',
      'general-surgery': 'General Surgery',
      'vascular-surgery': 'Vascular Surgery',
      'cardiovascular-surgery': 'Cardiovascular Surgery',
      'plastic-surgery-reconstructive-microsurgery':
        'Plastic surgery - reconstructive microsurgery',
      'pediatric-surgery': 'Pediatric surgery',
      'thoracic-surgery': 'Thoracic surgery',
      ophthalmology: 'Ophthalmology',
      rheumatology: 'Rheumatology',
      'family-medicine': 'Family medicine',
      'general-medicine': 'General medicine',
      'anesthesia-and-intensive-care': 'Anesthesia and intensive care',
      psychiatry: 'Psychiatry',
      'pediatric-psychiatry': 'Pediatric psychiatry',
      psychology: 'Psychology',
      'pathological-anatomy': 'Pathological anatomy',
      'oral-and-maxillofacial-surgery': 'Oral and maxillofacial surgery',
      orthodontics: 'Orthodontics',
      dentistry: 'Dentistry',
      'medical-genetics': 'Medical genetics',
      'geriatrics-and-gerontology': 'Geriatrics and gerontology',
      'medical-expertise': 'Medical expertise',
      'sports-medicine': 'Sports medicine',
      'emergency-medicine': 'Emergency medicine'
    }
  },
  errors_obj: {
    INVALID_REQUEST: 'Invalid request',
    DEACTIVATED_ACCOUNT: 'Your account deactivated, please contact support',
    NOT_AUTHORIZED: 'Not authorized',
    MODEL_NOT_FOUND: 'Not found',
    INTERNAL: 'Internal Server error, please try in a few mins',
    SID_MISSING: 'Required Sid',
    SID_EXPERIED: 'Expired Sid',
    EMAIL_TAKEN:
      'This email address is already associated with another account. Please use a different email address.',
    PHONENUMBER_TAKEN: 'This phone number is already in use. Please use a different one.',
    PHONE_TOO_MANY_ATTEMPTS: 'This phone number is too many attempts.',
    INVALID_CODE: 'Verification code is invalid',
    EXPIRED_CODE: 'Verification code is no longer available',
    BAD_CREDENTIALS: 'Username or password is incorrect',
    URLNAME_TAKEN: 'Already Exists Username',
    VERIFY_EXIST: 'Verify Exists',
    INVALID_VERIFICATION: 'Your verification link is no longer valid or expired.',
    EMAIL_NOT_REGISTERED: 'Email not registered',
    PHONE_NUMBER_NOT_REGISTERED: 'Phone number not registered',
    PENDING_RESET_PASSWORD: 'PENDING_RESET_PASSWORD',
    EXPIRED_RESET_PASSWORD: 'EXPIRED_RESET_PASSWORD',
    EMPTY_RESPONSE: 'Empty response from server',
    INTERNAL_CLIENT: 'Internal Client Error',
    NOT_ALLOWED_CREATE_ROOM: 'Not allowed to create room',
    NOT_ALLOWED_CREATE_SUBROOM: 'Not allowed to create subroom',
    INVALID_PASSWORD: 'Password must contain lowercase and uppercase letters and digits',
    INVALID_PASSWORD_CONFIRM: "Password doesn't match",
    INVALID_PASSWORD_OLD: 'Old Password is incorrect. Please try again.',
    INVALID_NAME:
      'Name must have at least 3 letters and contain only characters, digits and @ _ . #',
    INVALID_URLNAME: 'Url must contain only characters, digits, underscore and dot',
    INVALID_EMAIL: 'Invalid email',
    PENDING_RESET: 'Already pending reset',
    EXPIRED_RESET: 'Already expired reset token',
    PASSWORD_RESET: 'Password reset',
    NOT_FOUND_SOCIAL_USER: 'Not found social user',
    EMAIL_NOT_FOUND: 'Not found user',
    ALREADY_EXIST: 'Already exists User',
    TOKEN_INVALID: 'Token is invalid',
    TOKEN_EXPIRED: 'Token is expired',
    ROOMID_TAKEN: 'Already taken Room ID',
    NOT_ALLOWED: 'Not allowed to create room',
    SUBROOM_TAKEN: 'Already taken Subroom name',
    NOT_FOUND_EVENT: 'Not found event',
    PASSWORD_CONFIRM_INVALID: 'Confirm password does not match with password',
    PASSWORD_WEAK: 'Password is week',
    PASSWORD_OLD_INVALID: 'Old password is invalid',
    CONFLICT: 'Already exists',
    SAME: '',
    EMAIL_CODE_INVALID: 'The link is invalid',
    EMAIL_CODE_EXPIRED: 'The link is no longer available',
    NOT_PERMISSION: 'Account has no permission',
    USER_JOINED: 'User already joined',
    CODE_INVALID: 'Your invitation is no longer available, contact the sender for more details',
    BLOCKED: 'BLOCKED',
    SLOT_UNAVAILABLE: 'Slot unavailable. Please select a different time.',
    SLOT_CONFLICT: 'The selected time conflicts with an existing slot',
    FILE_TOO_LARGE: 'File too large',
    TOO_MANY_UPLOADS: 'Too many uploads',
    UPLOAD_LENGTH_REQUIRED: 'Upload length required',
    FILE_TYPE_NOT_ALLOWED: 'File type not allowed'
  },
  health: {
    screen_title: 'Health',
    back_to_home: '‹ Home',
    back_to_health: '‹ Health',
    edit_mode_toggle: 'Edit',
    done_toggle: 'Done',
    biological_age_label: 'Your biological age',
    key_markers: 'Key Markers',
    see_all: 'See all →',
    documents: 'Documents',
    add_document: '+ Add',
    no_documents_title: 'No documents yet',
    no_documents_subtitle: 'Upload your first health report to get started',
    parsed_badge: 'Parsed ✓',
    manual_badge: 'Manual ✎',
    delete_document_title: 'Delete this document?',
    delete_document_message:
      'Are you sure you want to delete this document? This action cannot be undone.',
    cancel: 'Cancel',
    delete: 'Delete',
    marker_fallback: 'Marker',
    loading_document: 'Loading document...',
    document_fallback: 'Document',
    markers_count: '{:count} Marker',
    markers_count_plural: '{:count} Markers',
    unknown_marker: 'Unknown',
    reference_prefix: 'Ref: ',
    no_markers_title: 'No markers parsed',
    no_markers_subtitle: 'This document did not contain parseable lab markers',
    view_original_pdf: 'View Original PDF',
    unknown_date: 'Unknown date',
    dash: '—',
    vs_last: 'vs last',
    baseline_record: 'Baseline record',
    normal_range_prefix: 'Normal range: ',
    reference_range_unavailable: 'Reference range unavailable',
    history: 'History',
    no_history: 'No history is available for this marker yet.',
    status_normal: 'Normal',
    status_low: 'Low',
    status_high: 'High',
    upload_title: 'Upload',
    drop_file_title: 'Drop your file here',
    drop_file_sub: 'PDF · JPG · PNG · DICOM\nBlood panels, MRIs, prescriptions, scans',
    type_blood_panel: '🩸 Blood Panel',
    type_mri_scan: '🧠 MRI / Scan',
    type_prescription: '💊 Prescription',
    type_genetics: '🧬 Genetics',
    file_selected: 'File selected',
    ai_found_markers: 'AI found {:count} markers 🎉',
    duplicate_report_title: 'Duplicate report',
    duplicate_report_message: 'This report is already in your health records.',
    from_prefix: 'From: ',
    uploaded_file: 'uploaded file',
    save_to_health: '✓ Save to Health',
    parsing: 'Parsing...',
    saving: 'Saving...',
    parse_for_review: 'Parse For Review',
    delete_marker: 'Delete marker?',
    delete_marker_message:
      'Are you sure you want to delete this marker? This action cannot be undone.'
  },
  lifetracker: {
    marker_detail_title: 'Marker Detail',
    marker_history: 'History',
    no_markers_yet: 'No markers yet',
    no_markers_subtitle: 'Voice notes and text entries will be analyzed for health markers',
    ai_extracted: 'AI Extracted',
    tap_for_history: 'Tap for history',
    loading_history: 'Loading history...',
    trend_up: '↑',
    trend_down: '↓',
    trend_flat: '—',
    trend_unknown: '—',
    category: 'Category',
    unit: 'Unit',
    reference_range: 'Reference Range',
    value: 'Value',
    date: 'Date',
    no_history: 'No history available',
    delete_category: 'Delete',
    delete_category_confirm_title: 'Delete category',
    delete_category_confirm_message:
      'This will permanently remove this category and all its records.',
    show_archived: 'Archived',
    show_active: 'Log',
    unarchive: 'Unarchive',
    streak_zero: 'Start logging to build a streak',
    streak_one_title: '1 day in a row',
    streak_one: 'Log today to keep it alive',
    streak_n: '{:count} days in a row'
  }
};

export default LANG_CONST;
